import { getAllChartName } from './../../helper/chart';
import uniqWith from 'lodash.uniqwith';
import isEqual from 'lodash.isequal';
import { useMemo } from 'react';
import { ICustomerOption } from '../shared';

/**
 * Get all chart variants
 * When there is 1 chart variant, the name of this chart will never be `All ${selectedCustomerLabel} Charts`
 */
export const getChartVariants = ({
  filteredCharts,
  selectedCustomer,
}: {
  filteredCharts: any;
  selectedCustomer: null | ICustomerOption;
}): any[] | null => {
  function createItems(chart: any): { name: string; id: string } {
    return {
      name: chart.chartDisplayName,
      id: chart.chartId,
    };
  }
  if (selectedCustomer && filteredCharts) {
    const items = filteredCharts.map(createItems);
    const uniqItems = uniqWith(items, isEqual);
    const allChartsItem = {
      name: getAllChartName(selectedCustomer.label),
      id: null,
    };

    /**
     * This is a bit dirty, but there is an explicit demand from the
     * customer that for spotify the 'top 200 daily' is the first chart
     * that is being shown. So we're explicitly looking for an ID here.
     */
    if (
      uniqItems.length >= 1 &&
      selectedCustomer.label.toLowerCase() === 'spotify'
    ) {
      const daily = uniqItems.find((item: any) => {
        return item.id === 1006;
      });
      if (daily) {
        const idx = uniqItems.indexOf(daily);
        uniqItems.splice(idx, 1);
        uniqItems.unshift(daily);
      }
    }

    return [...uniqItems, ...(uniqItems.length > 1 ? [allChartsItem] : [])];
  }

  return null;
};

/**
 * When a customer (e.g 'Spotify') is selected we want to filter and deduplicate
 * the available variants (e.g 'Spotify Top 200 Daily') so the charts tabs component
 * can render them.
 *
 * @returns {Array} array with objects with the name and id for every variant.
 */
export default function useChartVariants(
  filteredCharts: any,
  selectedCustomer: null | ICustomerOption
): any[] | null {
  return useMemo(() => getChartVariants({ filteredCharts, selectedCustomer }), [
    filteredCharts,
    selectedCustomer,
  ]);
}
